import React from 'react';
import { SunOutlined, MoonOutlined } from '@ant-design/icons';
import { useTheme } from '../../context/ThemeContext';
import { DARK, LIGHT } from '../../utilities/constants';
import { Flex } from 'antd';
import './Header.css';

const DayNightToggle = () => {
  const { theme, toggleTheme } = useTheme();

  const handleToggleTheme = () => {
    toggleTheme(theme === LIGHT ? DARK : LIGHT);
  };

  return (
    <Flex align="middle" className="theme-toggle-container">
      <MoonOutlined
        className="theme-toggle"
        style={{
          backgroundColor: theme === DARK ? 'var(--primary)' : '#e0e2e5',
        }}
        onClick={() => theme === LIGHT && handleToggleTheme()}
      />

      <SunOutlined
        className="theme-toggle"
        style={{
          backgroundColor: theme === LIGHT ? 'var(--primary)' : 'transparent',
        }}
        onClick={() => theme === DARK && handleToggleTheme()}
      />
    </Flex>
  );
};

export default DayNightToggle;
